import Default from "./ReadonlyVariableResource";
export * from "./ReadonlyVariableResource";

export default Default;
